<template>
    <div :class="isDark ? 'dark-bg' : ''" class="org-settings-view h-full overflow-auto p-4">
        <tabs v-model="selectedTab" :tabs="orgSettingTabs" />
    </div>
</template>

<script setup lang="ts">
import Tabs from '@/tabs/Tabs.vue'
import {isDark} from '@/theme/theme.service'
import {TabDefinition} from '@/tabs/TabDefinition.type'
import {usePanelManager} from '@tritt/multipanel'
import {ORG_SETTINGS} from '@/org-settings'
import {computed, inject, Ref} from 'vue'
import {findTab, orgSettingTabs} from '@/org-settings/tabs'
import emitter from '@/services/infrastructure/emitter'
import {ORG_SETTINGS_TAB_SWITCHED} from '@/types/events'
const panelId: Ref<number> | undefined = inject('panelId')
const {setPanelPath} = usePanelManager()

const props = defineProps({
    tab: {
        type: String,
        required: false
    }
})

const selectedTab = computed<TabDefinition>({
    get: () => {
        return findTab(props.tab || '')
    },
    set: (tab: TabDefinition) => {
        setPanelPath({...ORG_SETTINGS, queryValues: {tab: tab.key}, panelId: panelId?.value})
        // Emit event
        emitter.emit(ORG_SETTINGS_TAB_SWITCHED, tab.key)
    }
})
</script>

<style>
@reference "@/index.css";
@reference "tailwindcss";

.setting-header {
    @apply text-lg font-semibold;
}

.setting-group {
    /* @apply px-2 mb-4 w-full rounded-md bg-base-200/40 dark:bg-base-400/40 shadow-md hover:shadow-lg dark:shadow-green-200/20 dark:hover:shadow-green-200/30; */
    @apply px-2 mb-4 w-full rounded-md bg-base-200/40 shadow-md hover:shadow-lg;
    transition: box-shadow 0.2s ease-in-out;
}

.setting {
    @apply py-4 min-h-[74px] w-full grid items-center;

    &.with-border {
        @apply border-gray-300/50 border-t-2;
    }
}
</style>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.org-settings-view {
    background: url("/gradient-light.svg") no-repeat;
    background-size: 100% 100%;

    &.dark-bg {
        background: url("/gradient-dark.svg") no-repeat;
        background-size: 100% 100%;
    }
}

</style>